module.exports = __webpack_public_path__ + "img/st4.bce679b5.png";